// extracted by mini-css-extract-plugin
var _1 = "SelectIcon_large__91c03";
var _2 = "SelectIcon_medium__5ca29";
var _3 = "SelectIcon_mini__e1d33";
var _4 = "SelectIcon_root__2243a";
var _5 = "SelectIcon_xmini__3d06d";
export { _1 as "large", _2 as "medium", _3 as "mini", _4 as "root", _5 as "xmini" }
